module.exports = __webpack_public_path__ + "img/EXP-alt.2057dda2.svg";